import './Footer.css'

const Footer = () => {
    return (
        <div className='mt-2 d-flex flex-column flex-md-row rounded footer justify-content-between align-items-center position-relative'>
            {/* Follow us section */}
            <div className="d-flex flex-column align-items-center flex-grow-1">
                <h2 className="text-center mb-3">Follow us</h2>
                <ul className='follow-us-list d-flex justify-content-center'>
                    {/* Google Scholar */}
                    <li className='list-items mx-2'>
                        <a href="https://scholar.google.com/citations?hl=en&user=zpB9DusAAAAJ&view_op=list_works&sortby=pubdate" target="_blank" rel="noopener noreferrer">
                            <i className="fa-brands fa-google-scholar fa-beat-fade fa-2xl"></i>
                        </a>
                    </li>
                    {/* X (Twitter) */}
                    <li className='list-items mx-2'>
                        <a href="https://x.com/CRRajlabIITKgp" target="_blank" rel="noopener noreferrer">
                            <i className="fa-brands fa-x-twitter fa-beat-fade fa-2xl"></i>
                        </a>
                    </li>
                    {/* LinkedIn */}
                    <li className='list-items mx-2'>
                        <a href="https://www.linkedin.com/in/cr-raj-891541115/" target="_blank" rel="noopener noreferrer">
                            <i className="fa-brands fa-linkedin fa-beat-fade fa-2xl"></i>
                        </a>
                    </li>
                    {/* ResearchGate */}
                    <li className='list-items mx-2'>
                        <a href="https://www.researchgate.net/profile/C-Retna-Raj" target="_blank" rel="noopener noreferrer">
                            <i className="fa-brands fa-researchgate fa-beat-fade fa-2xl"></i>
                        </a>
                    </li>
                    {/* Mail */}
                    <li className='list-items mx-2'>
                        <a href='mailto:crraj@chem.iitkgp.ac.in'>
                            <i className="fa-solid fa-envelope fa-beat-fade fa-2xl"></i>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.coolseotools.com/website-visitor-counter" rel="noopener noreferrer" target="_blank" title="Web Counter">
                            <img src="https://www.coolseotools.com/website-visitor-counter/count/&style=style8&show=p&num=5&uid=bpF" title="Web Counter" alt="AtoZSEOTools Web Counter" />
                        </a>
                    </li>
                </ul>
            </div>

            {/* Our Sponsors Section */}
            <div className="d-flex flex-column align-items-center flex-grow-1">
                <h2 className="text-center mb-3">Our Sponsors</h2>
                <div className="d-flex justify-content-center flex-wrap gap-3">
                    {/* Sponsor Logos */}
                    <img src="images/iitkgp_logo1.png" alt="IIT Kharagpur" className="img-fluid mx-2" style={{ maxWidth: "100px" }} />
                    <img src="images/serbimp.png" alt="SERB" className="img-fluid mx-2" style={{ maxWidth: "100px" }} />
                    <img src="images/DST-Logo-1.jpg" alt="DST" className="img-fluid mx-2" style={{ maxWidth: "100px" }} />
                    <img src="images/stars.png" alt="STARS" className="img-fluid mx-2" style={{ maxWidth: "100px" }} />
                </div>
            </div>

            {/* Address Section */}
            <div className="d-flex flex-column align-items-center flex-grow-1">
                <div className="container address text-center">
                    Lab: A406, CRR Office: A405<br />
                    Department of Chemistry,<br />
                    JCG-PCR Science Block,<br />
                    Indian Institute of Technology Kharagpur, <br />
                    Kharagpur, India - 721302<br />
                    Email: <b>crraj@chem.iitkgp.ac.in</b><br />
                    Ph: <b>03222283348</b>
                </div>
                <br></br>
            </div>
            <div
                className="position-absolute start-0 bottom-0 ps-3 pb-2"
                style={{ fontSize: "1rem", color: "#000000ff" }} // Change color here
            >
                Maintained by Sudip
            </div>
        </div>
    )
}

export default Footer;